import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FAddressMiniFormMDP from "@/components/form/field/FAddressMiniFormMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FClientLanguageSelectFieldMDP from "@/components/form/field/FClientLanguageSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";


export default class FProfileFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({
    taskRoot,
    parent,
    myRefName,
    dataSelectorKey,
    disabled,
    readonly=false,
  }: {
    taskRoot: any;
    parent: any;
    myRefName: string;
    dataSelectorKey?: string;
    disabled: boolean;
    readonly?: boolean
  }) {
    super({
      myRefName: myRefName,
      dataSelectorKey: dataSelectorKey,
      disabled: disabled,
      readonly: readonly
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this.addField(
      new FSelectFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "gender",
        label: "Gender",
        boundaryClass: "col-6",
        mandatory: true,
        options: [
          { id: "FEMALE", name: "Female" },
          { id: "MALE", name: "Male" },
          { id: "OTHERS", name: "Others" },
        ],
        optionLabel: "name",
        optionValue: "id",
      })
    )
      .addField(
        new FPhoneFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "secondaryPhone",
          label: "Secondary Phone",
          boundaryClass: "col-6",
        })
      )
      .addField(
        new FSelectDateFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "dob",
          label: "Date Of Birth",
          boundaryClass: "col-6",
          mandatory: true,
          futureDaysDisabled: true,
          rules: "validate_age"
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "pan",
          label: "PAN",
          boundaryClass: "col-6",
          mandatory: true,
          rules:"validate_pan"
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "motherMaidenName",
          label: "Mother's Maiden Name",
          boundaryClass: "col-4",
          mandatory: true,
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "fatherName",
          label: "Father's Name",
          boundaryClass: "col-4",
          mandatory: true,
        })
      ).addField(
        new FClientLanguageSelectFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "clientLanguage",
          label: "Preferred Language",
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FAddressMiniFormMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "residentialAddress",
          disabled: taskRoot.taskDisabled,
          label: "Residential Address",
          mandatory: true,
        })
      );
  }

  getMyRef(): any {
    return this.parent.getProfileFormRef().$refs[this.myRefName];
  }

}
